import React, { FC } from "react";

interface H1TextType {
    content: string;
}
const H1Text: FC<H1TextType> = ({ content }) => {
    return (
        <h1 className="block grid mt-3 text-black max-w-4xl mx-auto font-normal" style={{ fontSize: "55px" }}>
            <span className=" text-blue-500 font-extrabold mb-3" style={{ fontSize: "65px", marginTop: "-13px" }}>
                Gallabox
            </span>
            {` ${content}`}
        </h1>
    );
};

export default H1Text;
